import { forwardRef, useState, useEffect } from 'preact/compat';
import { tryFocus } from '@/utils';
import {
	useAdvanced,
	useConfigStore,
	useProperties,
	useFormProps
} from '../stores/ConfigStore';
import { useFormStore } from '../stores/FormStore';
import SvgIcon from './SvgIcon';

const FeedbackButton = forwardRef(function FeedbackButton(props, ref) {
	const { formKey, showButton } = useFormProps();
	const { themeClass, text } = useConfigStore();
	const { trigger } = useProperties();
	const advanced = useAdvanced();
	const [show, setShow] = useState(false);
	useEffect(() => {
		setTimeout(() => {
			setShow(true);
		}, 100);
	}, []);
	const {
		formOpen,
		closeButtonRef,
		formType,
		buttonType,
		isPastBreakpoint,
		position,
		actions,
		screenshotActive
	} = useFormStore();

	const buttonTypeClass =
		buttonType === 'float'
			? `button-float ${isPastBreakpoint ? 'button-float-mobile' : ''}`
			: '';

	if (!showButton) {
		return null;
	}

	return (
		<button
			type="button"
			id={formType === 'slide' ? 'surveySliderBtn' : ''}
			class={
				formType === 'slide'
					? `notranslate btn btn-open-slider ${themeClass} ${buttonTypeClass} allow-button wcag`
					: `notranslate btn-open-survey btn btn-primary tab tab-${position} ${themeClass} allow-button wcag ${
							advanced.buttonStyle ? advanced.buttonStyle : ''
					  } ${buttonTypeClass} ${!trigger.button.icon ? 'no-icon' : ''} ${themeClass}`
			}
			data-button-for={formKey}
			onClick={actions.toggleForm}
			onKeyDown={e => {
				if (e.key === 'Tab' && !e.shiftKey && formOpen && !screenshotActive) {
					e.preventDefault();
					tryFocus(closeButtonRef.current);
				}
			}}
			style={{
				opacity: show ? 1 : 0,
				visibility: show ? 'visible' : 'hidden',
				...(!show && {
					transition: 'none!important'
				})
			}}
			ref={ref}
			ariaLabel={text.btnOpenText ?? 'Feedback'}
			data-testid="feedback-button"
		>
			{formType === 'slide' && buttonType === 'float' && formOpen ? (
				<span className="mopinion-close-icon">&times;</span>
			) : Boolean(trigger.button.icon) ? (
				<SvgIcon icon={`${trigger.button.icon}`} />
			) : null}
			{text.btnOpenText && formType !== 'slide' && <span>{text.btnOpenText}</span>}
		</button>
	);
});

export default FeedbackButton;
